import { ApolloClient, gql } from 'apollo-boost';
import { useDonorsQuery } from 'admin/pages/ServiceCollections/queries';
import { useEffect } from 'react';

const portfolioFiltersQuery = gql`
  query allPortfolios($enabled: Boolean, $hasTasks: Boolean) {
    allPortfolios(filters: { enabled: $enabled, hasTasks: $hasTasks }) {
      edges {
        node {
          name
          portfolioId
          enabled
          accountId
        }
      }
    }
  }
`;

export interface AllPortfolioFilters {
  allPortfolios: {
    accountId: number;
    enabled: boolean;
    name: string;
    portfolioId: number;
  }[];
}

export const getPortfolioFilters = (
  client: ApolloClient<object>,
  type: 'donor' | 'TI staff',
) => {
  return client.query<AllPortfolioFilters>({
    query: portfolioFiltersQuery,
    variables: {
      enabled: true,
      hasTasks: type === 'TI staff',
    },
    fetchPolicy: 'network-only',
  });
};

const relationshipManagerQuery = gql`
  query relationshipManagers($enabled: Boolean, $hasTasks: Boolean) {
    relationshipManagers(filters: { enabled: $enabled, hasTasks: $hasTasks }) {
      edges {
        node {
          dbId
          accountId
          firstName
          lastName
          email
        }
      }
    }
  }
`;

export interface AllRelationshipManagerFilters {
  relationshipManagers: {
    accountId: number;
    countTasks: number;
    dbId: number;
    email: string;
    firstName: string;
    lastName: string;
  }[];
}

export const getRelationshipManager = (
  client: ApolloClient<object>,
  type: 'donor' | 'TI staff',
) => {
  return client.query<AllRelationshipManagerFilters>({
    query: relationshipManagerQuery,
    variables: {
      enabled: true,
      hasTasks: type === 'TI staff',
    },
    fetchPolicy: 'network-only',
  });
};

export const donorsQuery = gql`
  {
    adminAccounts (filters: { type: "funder", enabled: true }) {
      edges {
        node {
          dbId
          name
          type
        }
      }
    }
  }
`;

export interface AdminAccounts {
  adminAccounts: {
    dbId: number;
    name: string;
  }[];
}

export const getDonorsFilters = (
  client: ApolloClient<object>,
) => {
  return client.query<AdminAccounts>({
    query: donorsQuery,
    variables: {
      enabled: true,
    },
    fetchPolicy: 'no-cache',
  });
};
